import React from "react";

function ChronicCondition() {
  return (
    <div>
      <div className="h-[370px] w-[370px] m-5 border rounded-lg">
        <div className="h-[13%] bg-[#FFD5B8] flex items-center justify-center rounded-md p-2">
          <h1 className="font-bold text-normal text-[#3b230d] mt-3">
            Chronic Conditions
          </h1>
        </div>
        <div className="h-[75%] overflow-y-auto bg-white scrollwidth border-2 border-t-[#FB7800]">
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
            ChronicCondition :
              <span className="font-medium text-gray-500"> Asthma</span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
            ChronicCondition :
              <span className="font-medium text-gray-500"> Hypertension</span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
            ChronicCondition :
              <span className="font-medium text-gray-500"> Renal Disease</span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
          <div className="items-center text-sm p-2 m-3 border rounded-md">
            <div className="font-semibold">
            ChronicCondition :
              <span className="font-medium text-gray-500"> Congestive Heart Failure</span>
            </div>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
        </div>
        <div className="footer h-[44px] bg-[#FFD5B8] rounded-md"></div>
      </div>
    </div>
  );
}

export default ChronicCondition;
